/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
import * as Sentry from '@sentry/browser';

Sentry.init({dsn: 'https://a76681c311c9428a816b98b01329b21c@sentry.io/1495926'});

require('./bootstrap');

window.Vue = require('vue');

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
import * as VeeValidate from 'vee-validate';

Vue.use(VeeValidate);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#app'
});

// Setup module
// ------------------------------

let App = function () {
    // var _preloader = function () {
    //     var el = document.querySelector('.preloader');
    //     if (el) {
    //         el.classList.add('d-none');
    //     }
    // }

    var _burgerMenu = function () {
        var burgerMenu = document.querySelector('.burger-menu');
        if (burgerMenu) {
            // var likes = document.querySelector('.btn-like');
            var headerWrapper = document.querySelector('.header-wrapper');
            var menu = document.getElementById('menu');
            var content = document.getElementById("content");
            var mobileLogo = document.getElementById('mobile-logo');
            var mobileStub = document.getElementById('mobile-stub');
            var bodySearchItems = document.getElementById("b-search-items");

            burgerMenu.addEventListener('click', function (e) {
                document.getElementsByTagName('body')[0].setAttribute("style", "overflow-y: hidden");
                // for (var i = 0; i < likes.length; i++) {
                //     likes[i].style.visibility = 'hidden';
                // }

                if (headerWrapper) {
                    headerWrapper.style.background = 'rgba(17, 17, 17, 0)';
                    headerWrapper.style.borderBottom = 'none';
                }

                menu.classList.add("_open");
                content.style.marginRight = '-525px';
                mobileStub.classList.add('_active');
                mobileLogo.classList.add('logo-behaviour');

                if (bodySearchItems) {
                    bodySearchItems.style.display = "none";
                }
            });

            document.querySelector('#burger-closer').addEventListener('click', function (e) {
                document.getElementsByTagName('body')[0].removeAttribute('style');
                // for (var i = 0; i < likes.length; i++) {
                //     likes[i].style.visibility = "visible";
                // }

                if (headerWrapper) {
                    headerWrapper.style.background = 'white';
                    headerWrapper.style.borderBottom = '1px solid #eee6e1';
                }

                menu.classList.remove("_open");
                mobileLogo.classList.remove('logo-behaviour');
                content.style.marginRight = '0';
                mobileStub.classList.remove('_active');

                if (bodySearchItems) {
                    bodySearchItems.style.display = "block";
                }
            });
        }
    }

    var _goTopBtn = function () {
        var gotTopBtn = document.createElement('a');
        gotTopBtn.setAttribute('id', 'go-top');
        gotTopBtn.setAttribute('title', 'Up');
        gotTopBtn.setAttribute('href', '#');
        gotTopBtn.innerHTML = '<i class="fas fa-chevron-up"></i>'

        document.querySelector('body').appendChild(gotTopBtn);
    }

    return {
        // Disable transitions before page is fully loaded
        initBeforeLoad: function () {
            // _preloader();
        },

        // Enable transitions when page is fully loaded
        initAfterLoad: function () {
        },

        // Initialize all components
        initComponents: function () {
        },

        initHeaderElementsToggle: function () {
            _burgerMenu();
            _goTopBtn();
        },

        // Initialize core
        initCore: function () {
            App.initComponents();
            App.initHeaderElementsToggle();
        }
    }
}();


// Initialize module
// ------------------------------

// When content is loaded
document.addEventListener('DOMContentLoaded', function () {
    App.initBeforeLoad();
    App.initCore();
});

// When page is fully loaded
window.addEventListener('load', function () {
    App.initAfterLoad();
});
